export default "__VITE_ASSET__DS1nD8PO__"